// FAQ tabs shared by the "FAQ Tabbed" section and any "FAQ – Questions (suite)" sections.
// Shopify caps a section at 50 blocks, so overflow questions live in extra sections and are
// moved into the first FAQ Tabbed section's tabs here. Pinned questions go to the top of their tab.
if (!customElements.get('indigo-faq-tabs')) {
  // Tab the visitor (or merchant in the editor) last opened; kept across editor re-renders.
  let selectedTab = null;

  const refreshFaqTabs = () => {
    const host = document.querySelector('indigo-faq-tabs');
    if (!host || !host.insertItem) return;

    host.querySelectorAll('[data-faq-generated]').forEach((el) => el.remove());
    document.querySelectorAll('indigo-faq-extra').forEach((extra) => {
      (extra.items || []).forEach((item) => host.insertItem(item));
    });
    host.updateTabs();
  };

  class IndigoFaqTabs extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', (event) => {
        const tab = event.target.closest('.faq-tab');
        if (tab) this.select(tab.dataset.tab);
      });
    }

    connectedCallback() {
      refreshFaqTabs();
    }

    insertItem(item) {
      const handle = item.dataset.category;
      const panel = this.querySelector(`.faq-panel[data-panel="${CSS.escape(handle)}"]`) || this.addTab(handle, item.dataset.categoryLabel);
      const before = item.hasAttribute('data-pinned') ? panel.querySelector('.faq-item:not([data-pinned])') : null;
      panel.insertBefore(item, before);
    }

    addTab(handle, label) {
      const tab = document.createElement('button');
      tab.type = 'button';
      tab.className = 'faq-tab';
      tab.textContent = label;
      tab.dataset.tab = handle;
      tab.dataset.faqGenerated = '';
      tab.setAttribute('role', 'tab');
      tab.setAttribute('aria-selected', 'false');
      tab.setAttribute('aria-controls', `faq-panel-${handle}`);
      this.querySelector('.faq-tabs').appendChild(tab);

      const panel = document.createElement('div');
      panel.className = 'faq-panel';
      panel.id = `faq-panel-${handle}`;
      panel.hidden = true;
      panel.dataset.panel = handle;
      panel.dataset.faqGenerated = '';
      panel.setAttribute('role', 'tabpanel');
      this.querySelector('.faq-panels').appendChild(panel);
      return panel;
    }

    updateTabs() {
      const tabs = Array.from(this.querySelectorAll('.faq-tab'));
      this.querySelector('.faq-tabs-wrapper').hidden = tabs.length < 2;
      if (!tabs.length) return;
      const keep = tabs.some((tab) => tab.dataset.tab === selectedTab);
      this.activate(keep ? selectedTab : tabs[0].dataset.tab);
    }

    select(handle) {
      selectedTab = handle;
      this.activate(handle);
    }

    activate(handle) {
      this.querySelectorAll('.faq-tab').forEach((tab) => {
        const active = tab.dataset.tab === handle;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active);
      });
      this.querySelectorAll('.faq-panel').forEach((panel) => {
        const active = panel.dataset.panel === handle;
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
      });
    }
  }

  class IndigoFaqExtra extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('.faq-item'));
      refreshFaqTabs();
    }

    disconnectedCallback() {
      // Take the questions back so they leave the FAQ with this section, and come back
      // with it if the theme editor re-inserts the same element (e.g. section reorder).
      this.querySelector('.faq-extra-items').append(...this.items);
      refreshFaqTabs();
    }
  }

  customElements.define('indigo-faq-tabs', IndigoFaqTabs);
  customElements.define('indigo-faq-extra', IndigoFaqExtra);

  // Theme editor: selecting a question in the sidebar opens its tab and expands it.
  document.addEventListener('shopify:block:select', (event) => {
    const item = document.querySelector(`indigo-faq-tabs [data-block-id="${CSS.escape(event.detail.blockId)}"]`);
    if (!item) return;
    item.closest('indigo-faq-tabs').select(item.closest('.faq-panel').dataset.panel);
    item.open = true;
    item.scrollIntoView({ block: 'center', behavior: event.detail.load ? 'auto' : 'smooth' });
  });
}
